import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Appeal from './pages/Appeal';
import AppealHistory from './pages/AppealHistory';
import AppealDetail from './pages/AppealDetail';
import ProtectedRoute from './components/ProtectedRoute';
import IdleTimeout from './components/IdleTimeout';

// Wraps a protected page with both the auth check (ProtectedRoute) and the
// idle-timeout warning/auto-logout (IdleTimeout). ProtectedRoute is outermost
// so unauthenticated visits redirect to /login before the idle timer ever starts.
function Protected({ children }) {
  return (
    <ProtectedRoute>
      <IdleTimeout>
        {children}
      </IdleTimeout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route
          path="/appeal"
          element={
            <Protected>
              <Appeal />
            </Protected>
          }
        />
        <Route
          path="/appeal-history"
          element={
            <Protected>
              <AppealHistory />
            </Protected>
          }
        />
        <Route
          path="/appeal-detail/:id"
          element={
            <Protected>
              <AppealDetail />
            </Protected>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;